import { render } from "./CustomersAppPage.vue?vue&type=template&id=01a1b07b&ts=true"
import script from "./CustomersAppPage.ts?vue&type=script&lang=ts"
export * from "./CustomersAppPage.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__